export function AttachCmdToObj(cmdObj, paramsObj) {
  if (paramsObj != null) {
    for (var paramKey in paramsObj) cmdObj[paramKey] = paramsObj[paramKey];
  }
}
